import goto from "./index";

export default {
  miniCourses() {
    goto.pushLayer("mini-courses");
  },
};
